document.querySelector("html").classList.remove("no-js");

const logs = false; // Set to false to disable console logs

const body = document.querySelector("body");
const html = document.querySelector("html");
const mq = window.matchMedia("(min-width: 800px)");

const indexCheck = document
  .querySelector("body")
  .classList.contains("template-index");
const productCheck = document
  .querySelector("body")
  .classList.contains("template-product");
const collectionCheck = document
  .querySelector("body")
  .classList.contains("template-collection");
const searchCheck = document
  .querySelector("body")
  .classList.contains("template-search");
const blogCheck = document
  .querySelector("body")
  .classList.contains("template-blog");
const testimonialsCarouselCheck = document.querySelector(".testimonials-list.carousel");

function debounce(func, wait) {
  let timeout;
  return function (...args) {
    const context = this;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

class SearchForm {
  constructor(target) {
    target.addEventListener("keyup", this.onSearchInputKeyUp.bind(this));
  }

  onSearchInputKeyUp(event) {
    let form = event.target.closest("form"),
      button = form.querySelector(".js-search-submit"),
      shouldDisableButton = event.target.value.length === 0;

    if (logs) {
      console.log(shouldDisableButton);
    }

    if (shouldDisableButton) {
      button.setAttribute("disabled", true);
      button.classList.add("btn-disabled");
      button.classList.add("opacity-025");
    } else {
      button.classList.remove("btn-disabled");
      button.classList.remove("opacity-025");
      button.removeAttribute("disabled");
    }
  }
}

// Intersection Observer
function intObs() {
  let observerSelector = ".observed",
    observerObject = document.querySelectorAll(observerSelector),
    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio >= 0.1) {
            entry.target.classList.add("in-view");
            entry.target.classList.remove("out-of-view");
          } else {
            entry.target.classList.remove("in-view");
            entry.target.classList.add("out-of-view");
          }
        });
      },
      {
        threshold: [0, 0.1, 1],
      },
    );

  observerObject.forEach((holder) => {
    observer.observe(holder);
  });

  window.addEventListener("resize", function () {
    observerObject.forEach((holder) => {
      observer.observe(holder);
    });
  });
}

function navigationClass() {
  let nav = document.querySelector("nav.main-nav"),
    menuLink = document.querySelector("button.js-menu"),
    html = document.documentElement;

  if (!menuLink.dataset.listenerAdded) {
    menuLink.addEventListener("click", function (event) {
      if (html.classList.contains("menu-active")) {
        html.classList.remove("menu-active");
        this.setAttribute("aria-expanded", "false");
        nav
          .querySelector(".main-nav__content")
          .setAttribute("aria-hidden", "true");
        isMenuOpen = false;
      } else {
        html.classList.add("menu-active");
        this.setAttribute("aria-expanded", "true");
        nav
          .querySelector(".main-nav__content")
          .setAttribute("aria-hidden", "false");
        isMenuOpen = true;
      }
    });
    menuLink.dataset.listenerAdded = "true"; 
  }
}


function detailsToggle() {
  if (!mq.matches) {
    return 
  } else {
  let navDropdowns = document.querySelectorAll(
    ".header__nav-item--has-dropdown",
  );

    navDropdowns.forEach((dropdown) => {
    let details = dropdown.querySelector("details");
    if (!details.dataset.listenerAdded) {

      let detailsHeading = details.querySelector("summary");

      detailsHeading.addEventListener("click", function (event) {
        event.preventDefault();
      });
      details.addEventListener("mouseover", function (event) {
        this.setAttribute("open", "true");     
     
        let dropdown = this.querySelector(".header__dropdown");

        if (dropdown) {
          dropdown.addEventListener("mouseleave", function () {

            dropdown.style.animation = "blurBack .25s ease-in-out forwards";
            setTimeout(() => {
              details.removeAttribute("open");
                dropdown.style.animation = "";
               
            }, 300); 
            
          });
        }
      });
     
      
      details.dataset.listenerAdded = "true"; 
    }
  });
  }
}




function fadeCarousel(slider, options) {
  if (!options) {
   var flkty = new Flickity(slider, {
     wrapAround: true,
     prevNextButtons: false,
     autoPlay: 4000,
     pageDots: false,
     fade: true,
   });
  } else {
   var flkty = new Flickity(slider, options);
  }
}

function heroCarousel() {
  let heroCarouselEl = document.querySelector(".hero--carousel");

  let options = {
    wrapAround: true,
    prevNextButtons: false,
    autoPlay:8000,
    pageDots: false,
    fade: true,
    pauseAutoPlayOnHover: false,
    draggable: false,
  },
  mobileOptions = {
    wrapAround: true,
    prevNextButtons: false,
    autoPlay: false,
    pageDots: false,
    fade: false,
    draggable: true,
  }; 

  if (heroCarouselEl) {
    if (mq.matches) {
      fadeCarousel(heroCarouselEl, options);
      return;
    }
    fadeCarousel(heroCarouselEl, mobileOptions);
  }
}

function runTestimonialsCarousel() {
  if (testimonialsCarouselCheck) {
    let carousels = document.querySelectorAll(".testimonials-list.carousel");
    carousels.forEach((carousel) => {
      fadeCarousel(carousel);
    });
  }
}


//  Collection / Search scripts
searchScripts = () => {
  new SearchForm(document.querySelector(".js-search-input"));
};

// Product scripts
productScripts = () => {

};

repeatScripts = () => {
  if (logs) {
    console.log("repeat scripts");
  }
  // Scripts that need to be re-run on window resize, infinite scroll etc.
};

universalScripts = () => {
  intObs();
  navigationClass();
  runTestimonialsCarousel();
  detailsToggle() 
  heroCarousel();
};

blogScripts = () => {
  // Infinite Scroll
};

editorScripts = () => {
  // Scripts that only run in the editor
  if (logs) {
    console.log("editor scripts");
  }
};

// All Scripts
runScripts = () => {
  if (logs) {
    console.log("run scripts");
  }
  universalScripts();
  repeatScripts();
  if (productCheck) {
    productScripts(); 
  } else if (searchCheck) {
    searchScripts();
  } else if (blogCheck) {
    blogScripts();
  }

  if (Shopify.designMode) {
    editorScripts();
  }
};

runScripts();

// Run scripts on window resize
window.addEventListener("resize", runScripts);
